import { PasswordResetStep } from '@repo/ui';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { usePasswordResetFlow } from './PasswordResetFlowContext';

interface PasswordResetStepGuardProps {
  step: PasswordResetStep;
  children: React.ReactNode;
}

export function PasswordResetStepGuard({
  step,
  children,
}: PasswordResetStepGuardProps) {
  const { canAccessStep, resetFlow } = usePasswordResetFlow();
  const navigate = useNavigate();

  useEffect(() => {
    const hasAccess = canAccessStep(step);

    if (!hasAccess) {
      // Se não tem acesso, reset o fluxo e redireciona para a primeira etapa
      resetFlow();
      navigate('/redefinir-senha', { replace: true });
    }
  }, [step, canAccessStep, resetFlow, navigate]);

  // Verifica novamente antes de renderizar
  if (!canAccessStep(step)) {
    return null;
  }

  return <>{children}</>;
}
